import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { useState } from 'react';
import styled from 'styled-components';
import { Skeleton } from '../skeleton/index';
export const Avatar = ({ src, alt, size = 32, ref, ...props }) => {
    const [status, setStatus] = useState('loading');
    return (_jsxs(Root, { "$size": size, ref: ref, ...props, children: [_jsx(Image, { src: src, onLoadingStatusChange: setStatus }), _jsx(Fallback, { children: status === 'loading' ? (_jsx(Skeleton, { width: "100%", height: "100%", variant: "circular" })) : (_jsx(Alt, { children: _jsx("p", { children: alt }) })) })] }));
};
const Root = styled(AvatarPrimitive.Root) `
  display: inline-flex;
  flex-shrink: 0;
  border-radius: 50%;
  height: ${({ $size }) => $size}px;
  width: ${({ $size }) => $size}px;
`;
const Image = styled(AvatarPrimitive.Image) `
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
`;
const Fallback = styled(AvatarPrimitive.Fallback) `
  width: 100%;
  height: 100%;
  border-radius: inherit;
`;
const Alt = styled.div `
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.color.black2[100]};
  color: ${(props) => props.theme.color.white[100]};
  border-radius: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
`;
//# sourceMappingURL=avatar.js.map